import { Skeleton } from 'antd';
export default Skeleton;
